// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overflow_main_dashboard {
  overflow-x: auto !important;
  background-color: red;
}

.bod_overflow {
  height: 100vh;
  overflow: hidden;
  overflow-y: hidden !important;
}

.link-active {
  color: red;
  background-color: #548dff !important;
}

.link-active:hover {
  color: white;
  background-color: #548dff !important;
}

.link-white {
  color: #548dff !important;
}

.link-white:hover {
  color: #548dff !important;
}

.background_nav1_header {
  background-color: #548DFF;
}

.side_nav_1_right {
  width: 100%;
}

.margin_left_m3 {
  margin-left: -60px;
}

.col6section {
  color: white;
}

.background_sidenav_two {
  background-color: white;
  padding-top: 5%;
  padding-bottom: 5%;
  border-radius: 6px;
}

.background_sidenav_two_t {
  background-color: white;
  padding-top: 3%;
  padding-bottom: 3%;
  border-radius: 6px;
}

.form-check-input[type=checkbox] {
  border: 1px solid lightgray !important;
  width: "20px";
  height: "20px";
}

.form-check-input[type=checkbox]:checked {
  background-color: #548dff !important;
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
  width: "20px";
  height: "20px";
}

.css-g0ek6u-MuiSvgIcon-root {
  color: #548dff !important;
}`, "",{"version":3,"sources":["webpack://./src/Assets/components/meetspace/sidemenu.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;EACA,qBAAA;AACJ;;AAGA;EACI,aAAA;EACA,gBAAA;EACA,6BAAA;AAAJ;;AAIA;EACI,UAAA;EACA,oCAAA;AADJ;;AAKA;EACI,YAAA;EACA,oCAAA;AAFJ;;AAMA;EACI,yBAAA;AAHJ;;AAMA;EACI,yBAAA;AAHJ;;AAYA;EACI,yBAAA;AATJ;;AAYA;EACI,WAAA;AATJ;;AAYA;EACI,kBAAA;AATJ;;AAYA;EACI,YAAA;AATJ;;AAkBA;EACI,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAfJ;;AAkBA;EACI,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAfJ;;AAuBA;EACI,sCAAA;EACA,aAAA;EACA,cAAA;AApBJ;;AAuBA;EACI,oCAAA;EACA,uBAAA;EACA,2BAAA;EACA,wBAAA;EACA,aAAA;EACA,cAAA;AApBJ;;AAuBA;EACI,yBAAA;AApBJ","sourcesContent":[".overflow_main_dashboard {\n    overflow-x: auto !important;\n    background-color: red;\n}\n\n\n.bod_overflow {\n    height: 100vh;\n    overflow: hidden;\n    overflow-y: hidden !important;\n\n}\n\n.link-active {\n    color: red;\n    background-color: #548dff !important;\n\n}\n\n.link-active:hover {\n    color: white;\n    background-color: #548dff !important;\n\n}\n\n.link-white {\n    color: #548dff !important;\n}\n\n.link-white:hover {\n    color: #548dff !important;\n\n}\n\n\n  \n\n\n\n.background_nav1_header {\n    background-color: #548DFF;\n}\n\n.side_nav_1_right {\n    width: 100%;\n}\n\n.margin_left_m3 {\n    margin-left: -60px;\n}\n\n.col6section {\n    color: white;\n}\n\n// .background_sidenav_one {\n//     background-color: #fbfcff;\n//     height: 92.5vh;\n//     overflow-y: hidden !important;\n// }\n\n.background_sidenav_two {\n    background-color: white;\n    padding-top: 5%;\n    padding-bottom: 5%;\n    border-radius: 6px;\n}\n\n.background_sidenav_two_t {\n    background-color: white;\n    padding-top: 3%;\n    padding-bottom: 3%;\n    border-radius: 6px;\n}\n\n\n\n\n\n// Checkbox style\n.form-check-input[type=\"checkbox\"] {\n    border: 1px solid lightgray !important;\n    width:\"20px\";\n    height:\"20px\"\n}\n\n.form-check-input[type=\"checkbox\"]:checked {\n    background-color: #548dff !important;\n    border: none !important;\n    box-shadow: none !important;\n    outline: none !important;\n    width:\"20px\";\n    height:\"20px\"\n}\n\n.css-g0ek6u-MuiSvgIcon-root {\n    color: #548dff !important;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
